import AOS from "aos"
import Bootstrap from "@bootstrap/bootstrap"
import Store from "@store/index"
import feather from "feather-icons"
import "livewire-vue"

require("bootstrap")

window.App = new Vue({
	i18n,
	store: Store,
	mounted() {
		require("bootstrap")
		feather.replace()

		AOS.init({
			duration: 1000,
		})

		;(function () {
			// Header sticky
			var $header = document.getElementById("header")
			var sticky = false

			setTimeout(function () {
				document.body.classList.remove("preload")
			}, 500)

			window.addEventListener("scroll", e => {
				if (window.scrollY > $header.offsetHeight + 30 && !sticky) {
					$header.classList.add("sticky")
					sticky = true
				}

				if (window.scrollY < $header.offsetHeight + 30) {
					$header.classList.remove("sticky")
					sticky = false
				}
			})
		})()
	},
}).$mount(document.getElementById("app"))
